import { useSelector } from 'react-redux';
import { selectIsConfigurationTabEnabled } from '../../selectors';

export const useConfigurationTabEnabled = (): boolean => {
  const isConfigurationTabEnabled = useSelector(selectIsConfigurationTabEnabled);

  return isConfigurationTabEnabled;
};
